
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { IOfferOption, OfferProvider } from '@alao-frontend/core'
import OfferCardDetailsTop from '~/components/offers/OfferCard/OfferCardDetails/OfferCardDetailsTop.vue'
import OfferCardDetailsContent from '~/components/offers/OfferCard/OfferCardDetails/OfferCardDetailsContent.vue'
import OfferCardDetailsBottom from '~/components/offers/OfferCard/OfferCardDetails/OfferCardDetailsBottom.vue'
import AppProviderRating from '~/components/AppProviderRating/AppProviderRating.vue'
import OfferMainDetails from '~/components/offers/OfferMainDetails'
import OfferOptions from '~/components/offers/OfferOptions'
import OfferCardExclusiveLabel from '~/components/offer-card/OfferCardExclusiveLabel.vue'
import OfferCardDiscountLabel from '~/components/offer-card/OfferCardDiscountLabel.vue'

import type { Theme } from '~/types/theme'

import { FeatureFlags } from '~/core/config/feature-flags'
@Component({
  components: {
    OfferCardExclusiveLabel,
    OfferCardDetailsTop,
    OfferCardDetailsContent,
    OfferCardDetailsBottom,
    AppProviderRating,
    OfferMainDetails,
    OfferOptions,
    OfferCardDiscountLabel,
  },
})
export default class SimpleOfferCardDetails extends Vue {
  @Prop({ required: false, default: '', type: String })
  readonly title!: string

  @Prop({ required: true, default: () => ({}), type: Object })
  readonly provider!: OfferProvider

  @Prop({ required: true, default: () => [], type: Array })
  readonly detailOptions!: IOfferOption[]

  @Prop({ required: true, default: () => [], type: Array })
  readonly benefitOptions!: IOfferOption[]

  @Prop({ required: true, default: '', type: String })
  readonly slug!: string

  @Prop({
    required: false,
    default: 'light',
    type: String,
  })
  readonly theme!: Theme

  @Prop({ required: true, default: 0, type: Number })
  readonly effectivePercent!: number

  @Prop({ default: 0, type: Number })
  readonly progressBar!: number | null

  @Prop({ default: null, type: String })
  readonly endDateInFewDays!: string | null

  @Prop({ default: false, type: Boolean })
  readonly isAlaoExclusive!: boolean

  get detailBindOptions () {
    return {
      optionsType: 'details',
      options: this.detailOptions,
      bgColor: this.theme === 'dark' ? 'rgba(238, 127, 26, 0.30)' : '#FBEEE2',
      textColor: this.theme === 'dark' ? '#ffffff' : '#444444',
      highlightBold: true,
    }
  }

  get benefitBindOptions () {
    return {
      optionsType: 'benefits',
      options: this.benefitOptions,
      bgColor: this.theme === 'dark' ? 'rgba(117, 174, 216, 0.30)' : '#EDF3F9',
      textColor: this.theme === 'dark' ? '#ffffff' : '#444444',
      highlightBold: true,
    }
  }
}
